import * as React from 'react';

import {EntityPill} from 'shells/entity-pill/entity-pill';

import type {GetContactAudienceMemberships_contact_audienceMembershipsSubscribed as SubscribedAudiences} from 'nutshell-graphql-types';

type Props = {
    subscribedMemberships: SubscribedAudiences[];
    contactName: string;
    onRemove: (membershipId: string) => void | null | undefined;
};

export function ContactSubscribedAudiences(props: Props) {
    return (
        <div>
            {props.subscribedMemberships.length ? (
                props.subscribedMemberships.map((membership) => {
                    return (
                        <EntityPill
                            key={membership.id}
                            isSmall={true}
                            name={membership.audience.name}
                            type='light'
                            onRemove={
                                !membership.audience.isWebFX && props.onRemove
                                    ? () => {
                                          props.onRemove(membership.id);
                                      }
                                    : undefined
                            }
                            removeButtonTooltip='Remove from audience'
                        />
                    );
                })
            ) : (
                <i>{props.contactName} isn’t in any audiences</i>
            )}
        </div>
    );
}
